export function groupItemsByDate(items) {
  if (!items || items.length === 0) return [];

  const parseDate = (val) => {
    if (!val) return 0;
    if (val.seconds || val._seconds) return (val.seconds || val._seconds) * 1000;
    const d = new Date(val);
    return isNaN(d.getTime()) ? 0 : d.getTime();
  };

  const sorted = [...items].sort((a, b) => {
    const da = parseDate(a.createdAt);
    const db = parseDate(b.createdAt);
    return db - da;
  });

  const groups = {
    'Today': [],
    'Yesterday': [],
    'Previous 7 Days': [],
    'Older': []
  };

  const now = new Date();
  const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  
  const yesterdayStart = new Date(todayStart);
  yesterdayStart.setDate(yesterdayStart.getDate() - 1);
  
  const sevenDaysStart = new Date(todayStart);
  sevenDaysStart.setDate(sevenDaysStart.getDate() - 7);

  sorted.forEach(item => {
    const timestamp = parseDate(item.createdAt);
    if (!timestamp) {
      groups['Older'].push(item);
      return;
    }

    const d = new Date(timestamp);
    if (d >= todayStart) {
      groups['Today'].push(item);
    } else if (d >= yesterdayStart) {
      groups['Yesterday'].push(item);
    } else if (d >= sevenDaysStart) {
      groups['Previous 7 Days'].push(item);
    } else {
      groups['Older'].push(item);
    }
  });

  return Object.keys(groups)
    .filter(key => groups[key].length > 0)
    .map(key => ({ label: key, items: groups[key] }));
}
